import React from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { INCREASE_LIMITS_CONTINUE_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { GA_LEVEL } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { AUTH_PROFILE_GA_AML_LEVEL, AUTH_PROFILE_GA_LIMITS } from 'apps/auth/constants/UrlConstants';
import { resolveArguments } from 'apps/auth/helpers/utils';

const ProfileGAAmlLevelInfoPage = (props) => {
    const expectedGALevel = props.current_limit + 1;
    const changeIcon = (level) => {
        if (level === 1) {
            return 'id-card-80';
        }
        if (level === 2 || level === 3) {
            return 'address-card-thin';
        }
        if (level === 4) {
            return 'bank-building-card-thin';
        }
    };

    return (
        <BaseLayout showChat={false}>
            <InfoPage
                iconName={changeIcon(props.current_limit)}
                iconColor="primary"
                headerText={
                    <>
                        <span>{resolveArguments(props.profilePurpleBlock, props.aml_level_name)}</span>&nbsp;
                        {props.increase_block}
                    </>
                }
                secondaryText={props.increase_sub_block}
                topButtonCaption={props.notificationButton}
                topButtonType="link"
                topButtonLink={AUTH_PROFILE_GA_LIMITS}
                primaryButtonCaption={props.nextButton}
                primaryButtonType="link"
                primaryButtonLink={`${AUTH_PROFILE_GA_AML_LEVEL}/${props.current_limit}/docs`}
                primaryButtonOnClick={() => {
                    amplitude.getInstance().logEvent(INCREASE_LIMITS_CONTINUE_CLICKED, { [GA_LEVEL]: expectedGALevel });
                }}
            />
        </BaseLayout>
    );
};
const mapStateToProps = (state) => {
    return {
        aml_level_name: state.messages.pageMessages.aml_level_name,
        increase_block: state.messages.pageMessages.increase_block,
        increase_sub_block: state.messages.pageMessages.increase_sub_block,
        nextButton: state.messages.pageMessages.nextButton,
        notificationButton: state.messages.pageMessages.notificationButton,
        profilePurpleBlock: state.messages.pageMessages.profilePurpleBlock,
        current_limit: state.extra.current_limit,
    };
};
export default connect(mapStateToProps)(BasePage(ProfileGAAmlLevelInfoPage));
